"use client";

// Orchanta studio mark — the "A·Loop" logo. Monochrome (inherits the muted text colour
// for the given theme) so it sits cleanly in the host product's nav/footer.
const THEMES = {
  dark: { base: "text-white/45", hover: "group-hover:text-white/90" },
  light: { base: "text-muted-foreground", hover: "group-hover:text-foreground" },
} as const;

export function OrchantaMark({
  size = "sm",
  theme = "dark",
}: {
  size?: "sm" | "md";
  theme?: "dark" | "light";
}) {
  const px = size === "md" ? 20 : 16;
  const textSize = size === "md" ? "text-sm" : "text-xs";
  const t = THEMES[theme];

  return (
    <span className="group relative inline-flex items-center gap-2 select-none">
      <svg
        width={px}
        height={px}
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden
        className={`${t.base} ${t.hover} transition-colors duration-300`}
      >
        <path d="M24 7 A17 17 0 1 1 9.7 15" fill="none" stroke="currentColor" strokeWidth="4.4" strokeLinecap="round" />
        <path d="M24 1.5 L24 12.5 L33 7 Z" fill="currentColor" />
        <circle cx="24" cy="24" r="5.4" fill="currentColor" />
      </svg>
      <span className={`relative ${textSize} font-medium tracking-wide ${t.base} ${t.hover} transition-colors duration-300`}>
        Orchanta
      </span>
    </span>
  );
}
